import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@type/index';
import { vendorMeByDomain } from '..';

export const useGetVendorByDomain = (hostName: string, options?: UseQueryOptions<typeof vendorMeByDomain>) =>
  useQuery({
    queryKey: ['vendor-me-by-domain', hostName],
    queryFn: () => vendorMeByDomain(hostName),
    enabled: !!hostName,
    ...options,
  });
